import React, { Fragment } from 'react';
import { Link } from 'react-router-dom';
import DefaultHeader from '../../container/default-layout/header';
import DefaultSideBar from '../../container/default-layout/side.bar';
import { DefaultFooter } from '../../container/default-layout/footer';
import { TableState } from '../../../types/index';
import AppService from "../../../services/app.service";
import Loader from '../../../components/loader';
import AlertDialogSlide from '../../../components/deleteModal';
import Table from "../../../components/Table";

let stakeholders = '';
class Stakeholder extends React.Component<
    any,
    any
> {

    readonly state: TableState = {
        columns: [
            {
                dataField: "value",
                text: "ID",
                sort: true,
                classes: "content-body",
                headerStyle: { minWidth: 50 },
                headerClasses: "table_header_color",
                align: "left",
            }, {
                dataField: "label",
                text: "Name",
                sort: true,
                classes: "content-body",
                headerClasses: "table_header_color",
                align: "left",
            },
            {
                dataField: "description",
                text: "Description",
                sort: true,
                classes: "paragraph-in-table content-body",
                headerClasses: "table_header_color",
                align: "left",
            },
            {
                dataField: "action",
                text: "Action",
                classes: "text-center",
                headerStyle: {width: 150},
                headerClasses: "text-center",
                align: "center",
                formatter:(cell, record) => {
                    return (
                        <Fragment>
                            <Link
                                className="btn btn-primary btn-sm"
                                to={`stakeholders/edit/${record.value}`}
                                style={{ marginRight: '5px' }}>
                                <i className="fa fa-edit" title="Edit Stakeholder" />
                            </Link>
                            <button
                                className="btn btn-danger btn-sm buttons"
                                onClick={() => this.deleteRecord(record.value, record.label)}
                                style={{ marginRight: '5px' }}>
                                <i className="fa fa-trash" title="Delete Stakeholder" />
                            </button>
                        </Fragment>
                    );
                }
            }
        ],
        data: [],
        value: 0,
        isShowingModal: false,
        loading: false
    };

    handleClick = () => this.setState({ isShowingModal: true })
    handleClose = () => this.setState({ isShowingModal: false })

    deleteRecord(record, name) {
        this.setState({ value: record });
        stakeholders = name;
        this.handleClick();
    }

    handleProcess = async () => {
        this.handleClose();
        this.setState({ loading: true });
        const stakeholder = await AppService.delete(this.state.value, 'stakeholders');
        if (stakeholder.status === 200) {
            this.setState({ data: stakeholder.data });
        }
        this.setState({ loading: false });
    }

    loadData = async () => {
        this.setState({ loading: true });
        const stakeholder = await AppService.getAll('stakeholders/getAll');
        this.setState({ data: stakeholder.data });
        this.setState({ loading: false });
    }

    componentWillMount = () => {
        this.loadData();
    }

    render() {

        return (
            <div>
                <div className="page">
                    <DefaultHeader history={this.props.history} />
                    <div className="page-content d-flex align-items-stretch fields-font">
                        <DefaultSideBar activeSMLink={true} />
                        <div className="content-inner">
                            {/* <!-- Page Header--> */}
                            <header className="page-header">
                                <div className="container-fluid">
                                    <h2 className="heading">Stakeholder Management</h2>
                                </div>
                            </header>
                            {/* <!-- Breadcrumb--> */}
                            <div className="breadcrumb-holder container-fluid">
                                <ul className="breadcrumb">
                                    <li className="breadcrumb-item breadcrumb-list"><Link to='/dashboard'>Dashboard</Link></li>
                                    <li className="breadcrumb-item active breadcrumb-list">Stakeholder Management</li>
                                </ul>
                            </div>
                            <section className="tables">
                                <div className="container-fluid">
                                    <div className="row">
                                        <div className="col-lg-12">
                                            <div className="card">
                                                <div className="card-close">
                                                    <div className="dropdown">
                                                        <Link className="dropdown-toggle" to='/stakeholders/add'><i className="fas fa-plus" title='Add Stakeholder' /></Link>
                                                    </div>
                                                </div>
                                                <div className="card-header d-flex align-items-center">
                                                    <h3 className="sub-heading">Stakeholders</h3>
                                                </div>

                                                <div className="card-body">
                                                    <div className="table-responsive data-table-wrapper table-heading">
                                                        <Table
                                                            data={this.state.data}
                                                            columns={this.state.columns}
                                                            remote={false}
                                                            id="value"
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </section>
                            <DefaultFooter />
                            {(this.state.loading) && <div className="overlay">
                                <Loader loading={this.state.loading} />
                            </div>}
                        </div>
                    </div>
                </div>
                <AlertDialogSlide
                    show={this.state.isShowingModal}
                    handleNo={this.handleClose}
                    handleYes={this.handleProcess}
                    title="Delete Stakeholder"
                >
                    <p className="fields-font">Are you sure you want to delete the stakeholder <span className="span">{stakeholders}</span> ?</p>
                </AlertDialogSlide>
            </div>

        );
    }

}

export default Stakeholder;